import { Box, FormField, SegmentedToggle, SidePanel } from "@wix/design-system";
import { LinkSmall, UploadExportSmall } from "@wix/wix-ui-icons-common";
import classNames from "classnames";
import React, { useContext, useRef, useState } from "react";
import { ModalServiceContext, PluginsEventsContext, RicosContext } from "./../../ricos-context";
import { MEDIA_POPOVERS_TABS_NAMES_BI } from "./../../wix-rich-content-common";
import { UiComponentsProvider, useClickOutside } from "./../../ui-components";
import { useBiNext } from "../../_shared/use-bi-next";
import { INSERT_PLUGIN_MODAL, INSERT_PLUGIN_MODAL_SOURCE_TOGGLE } from "../dataHooks";
import classes from "../statics/styles/insert-modal-scss";
import { AUDIO_TYPE } from "../types";
import { AudioEmbed } from "./audio-embed";
import { AudioUpload } from "./audio-upload";
const SourceOptionValue = {
  EMBED: "embed",
  UPLOAD: "upload"
};
const InsertModal = ({
  nodeId,
  componentData,
  handleFileSelection,
  handleFileUpload,
  fetchData,
  embedType,
  modalId
}) => {
  const { t, isMobile, environment } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext) || {};
  const pluginsEvents = useContext(PluginsEventsContext);
  const logBi = useBiNext();
  const modalRef = useRef(null);
  useClickOutside({
    containerRef: modalRef,
    onClickOutside: (_event) => {
      closeModal();
    },
    triggerOn: "pointerdown"
  });
  const [selectedSource, setSelectedSource] = useState(
    embedType || componentData?.audio?.src?.url ? "embed" : "upload"
  );
  const onSourceToggleClick = (_, value) => {
    selectedSource !== value && pluginsEvents.publishPluginPopoverTabSwitch?.({
      pluginId: AUDIO_TYPE,
      buttonName: MEDIA_POPOVERS_TABS_NAMES_BI[value.toLowerCase()]
    });
    setSelectedSource(value);
    logBi({ dataHook: INSERT_PLUGIN_MODAL_SOURCE_TOGGLE });
  };
  const closeModal = () => {
    modalService.closeModal(modalId);
  };
  return /* @__PURE__ */ React.createElement(UiComponentsProvider, null, /* @__PURE__ */ React.createElement(
    "div",
    {
      ref: modalRef,
      tabIndex: -1,
      className: classNames(
        classes.modal,
        environment === "liveSite" ? classes.liveSite : void 0
      )
    },
    /* @__PURE__ */ React.createElement(
      SidePanel,
      {
        onCloseButtonClick: closeModal,
        skin: "floating",
        width: isMobile ? "100%" : 288,
        height: isMobile ? "100vh" : void 0,
        dataHook: INSERT_PLUGIN_MODAL
      },
      /* @__PURE__ */ React.createElement("div", { "data-drag-handler": "true" }, /* @__PURE__ */ React.createElement(
        SidePanel.Header,
        {
          showDivider: true,
          className: classes.header,
          title: t("Audio_Modal_Header_Title")
        }
      )),
      /* @__PURE__ */ React.createElement(Box, { direction: "vertical", padding: "SP3", gap: "SP3" }, /* @__PURE__ */ React.createElement(FormField, { label: t("Audio_Modal_Toggle_Source_Label") }, /* @__PURE__ */ React.createElement(
        SegmentedToggle,
        {
          defaultSelected: selectedSource,
          size: "small",
          onClick: onSourceToggleClick,
          dataHook: INSERT_PLUGIN_MODAL_SOURCE_TOGGLE
        },
        /* @__PURE__ */ React.createElement(SegmentedToggle.Button, { value: SourceOptionValue.EMBED, prefixIcon: /* @__PURE__ */ React.createElement(LinkSmall, null) }, t("MediaModal_Tabs_Embed")),
        /* @__PURE__ */ React.createElement(
          SegmentedToggle.Button,
          {
            value: SourceOptionValue.UPLOAD,
            prefixIcon: /* @__PURE__ */ React.createElement(UploadExportSmall, null)
          },
          t("MediaModal_Tabs_Upload")
        )
      )), selectedSource === "embed" && /* @__PURE__ */ React.createElement(
        AudioEmbed,
        {
          componentData,
          closeModal,
          fetchData
        }
      ), selectedSource === "upload" && /* @__PURE__ */ React.createElement(
        AudioUpload,
        {
          nodeId,
          handleFileSelection,
          handleFileUpload,
          closeModal
        }
      ))
    )
  ));
};
export {
  InsertModal
};
//# sourceMappingURL=InsertModal.js.map
